import React from "react";

const Message = ({myMessage,content,time}: {myMessage: boolean;content: string;time: string})=>{
    return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: myMessage ? 'flex-end' : 'flex-start',
          marginBottom: 18
        }}>
          <div
            style={{
              background: myMessage ? '#3380FF' : '#f3f4f6',
              color: myMessage ? '#fff' : '#232323',
              borderRadius: myMessage ? '18px 4px 18px 18px' : '4px 18px 18px 18px',
              padding: '10px 18px',
              maxWidth: '70%',
              fontSize: '1.05rem',
              fontWeight: 500,
              boxShadow: myMessage ? '0 2px 8px rgba(51,128,255,0.08)' : '0 1px 4px rgba(0,0,0,0.04)',
              wordBreak: 'break-word',
              textAlign: 'left',
            }}
          >
            {content}
          </div>
          <span style={{
            fontSize: '0.78rem',
            color: '#a0a0a0',
            marginTop: 4,
            marginRight: myMessage ? 4 : 0,
            marginLeft: myMessage ? 0 : 4,
            alignSelf: myMessage ? 'flex-end' : 'flex-start'
          }}>{new Date(time).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
        </div>
    );
};

export default Message;